const LOCATION_STORAGE_KEY = process.env.NODE_ENV === "production" ? "LOCATION_KEY" : "LOCATION_KEY_DEV";

export const setLocation = (location) => {
  localStorage.setItem(LOCATION_STORAGE_KEY, location);
}

export const getLocation = () => {
  return localStorage.getItem(LOCATION_STORAGE_KEY);
}